import { ContentDView } from './ContentDView'

/**
 * ContentDPage - Main Content Drafter screen.
 *
 * Features a collapsible session sidebar on the left, chat in the center,
 * and document panel on the right. Starts by selecting a completed Content Foolscap.
 */
export function ContentDPage() {
  return <ContentDView />
}
